<div class="affiliate_page_wrap">
    <div class="affiliate_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="affi_top_contents">
                        <h1 class="text-center">트링카를 홍보하고
                            <br>수익도 함께 창출해 보세요! </h1>
                        <a id="signUpAtShareASale" href="https://www.shareasale.com/shareasale.cfm?merchantID=98815" target="_blank">
                            <i class="fa fa-sign-in"></i>
                            ShareASale에서 등록
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="benefits_sections">
        <div class="benefits_outer">
            <div class="commission_sections">
                <div class="commission_header">
                    <img src="../../../assets/images/CommisionDetails.png" alt="image">
                    <h2>수익금 혜택 정보</h2>
                </div>
                <div class="commission_body">
                    <ul>
                        <!-- <li>무료 가입 - $0.30</li> -->
                        <li>유료 요금제 구독 - 25%</li>
                    </ul>
                </div>
            </div>

            <div class="commission_sections OtherBenefits_section">
                <div class="commission_header">
                    <img src="../../../assets/images/otherBenefits.png" alt="benefits">
                    <h2>기타 혜택</h2>
                </div>
                <div class="commission_body">
                    <ul>
                        <li>높은 전환율(20-25%)</li>
                        <li>디바이스 간 추적</li>
                        <li>90일 쿠키 기간 연장</li>
                        <li>얼리버드 보상</li>
                        <li>최고 수준의 제휴 지원</li>
                    </ul>
                </div>
            </div>

        </div>
        <!-- <div class="container">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-lg-4">
                    <div class="benefits_cards">
                        <h2>Commision Details</h2>
                        <ul>
                            <li>Free Sign-ups - $0.21</li>
                            <li>Paid plan subscription - $20</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="benefits_cards">
                        <h2>Other Benefits</h2>
                        <ul>
                            <li>Great conversion rates (20-30%)</li>
                            <li>Cross-device tracking</li>
                            <li>Extended 90-day cookie window</li>
                            <li>Early bird rewards</li>
                            <li>Top-class affiliate support</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div> -->
    </div>


    <div class="why_become_affiliate_sectioin">
        <div class="container">
            <div class="row">
                <div class="col-md-9">
                    <h2>제휴 프로그램에 등록해야 하는 이유는 무엇인가요?</h2>
                    <div class="HeadingSubLine"></div>
                    <p>문법 및 문장 교정은 쉬은 일이 아니며, 대부분의 온라인 문법 검사 툴이 학술 및 기술 텍스트에는 성과를 내지 못합니다. Trinka는 AI 및 ML 기술과 수십 년간 축적된 업계
                        전문성을 활용하여 오류 없는 기술 및 학술 논문
                        <br>작성에 필요한 모든 사항을 제안합니다. Trinka는 전적으로 무료로 이용 가능하며, 브라우저 플러그인과
                        <br>MS Word 플러그인을 통해 온라인으로 이용할 수 있습니다.</p>
                    <p>Trinka와 파트너쉽을 맺게 되면, 학술 전문가와 학술 기관을 도울 수 있을 뿐 아니라 최소의 노력으로 꾸준한
                        <br>수익을 창출할 수 있습니다. Trinka가 모든 어려운 작업을 처리하므로 사용자는
                        <br>유용한 최신 콘텐츠와 제안 사항에 중점을 두고 모든 정모를 제공함으로써 고객 관계를 지속적으로 유지할 수 있습니다.
                    </p>
                </div>
                <div class="col-md-3">
                    <div class="affiliate_img">
                        <img src="../../../assets/images/anAffiliate.png" alt="affiliate">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="Affiliate_FAQ_Seciton">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="faq_affiliate_sections">
                        <h2>제휴 프로그램 FAQs</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header" id="heading-1">
                                <h5 class="mb-0">
                                    <a role="button" data-toggle="collapse" href="#collapse-1" aria-expanded="true" aria-controls="collapse-1">
                                        트링카 제휴 프로그램 소개
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-1" class="collapse show" data-parent="#accordion" aria-labelledby="heading-1">
                                <div class="card-body">
                                    <p>트링카의 제휴 프로그램은 간단하고 효과적인 방식으로 운영되고, 프로그램 등록자가 자신의 웹사이트(또는 소셜미디어 프로필, 이메일, 전자책 등)에
                                        <br>간단한 배너나 추적 텍스트 링크를 삽입하는 것인데, 해당 배너나 링크를 통해 사용자가 Trinka를 가입 설치할 때마다 등록자는 수익금을 받게 됩니다.
                                        Trinka는 무료이므로, 제휴 프로그램 등록자는 과도한 홍보 활동을 하지 않아도 높은 수익을 올릴 수 있습니다. 웹사이트에 배너나 링크를 삽입하기만
                                        <br>하면 되는데, 높은 성과를 보이면 높은 수익금을 지급받습니다.</p>
                                    <p>모든 문의는 이메일
                                        <a href="mailto:marketing@trinka.ai.">marketing@trinka.ai.</a>로 해주시기 바랍니다.</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="heading-2">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-2" aria-expanded="false" aria-controls="collapse-2">
                                        트링카 제휴 프로그램에는 누가 등록할 수 있나요?
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-2" class="collapse" data-parent="#accordion" aria-labelledby="heading-2">
                                <div class="card-body">
                                    <p>트링카는 학생, 연구원, 과학자, 전문가, 언어에 열정이 있는 사람, 영어로 글을 쓰는 모든 사람 등 세계 전역의 사람들을 돕습니다. 트링카a의 제휴
                                        <br>프로그램은 글쓰기 관련 웹사이트나 블로그와 잘 어울리는 짝을 이룹니다. 뿐만 아니라, 교육, 과학, 기술, 경력 개발, 그 외 많은 분야 등의 콘텐트를
                                        중점
                                        <br> 생산하면서 트링카의 다양한 사용자 기반에 어필하며 큰 성과를 내는 제휴 활동자도 여럿 있습니다.</p>
                                    <p>이나고의 사명에 부합하는 콘텐트를 생산하며 관련성 있는 최신 콘텐트를 잘 구성해 놓으면 제휴 프로그램에 참여할 수 있는 가능성이 극대화됩니다.</p>

                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-3">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-3" aria-expanded="false" aria-controls="collapse-3">
                                        어떻게 트링카 제휴 프로그램에 등록해 활동할 수 있나요?
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-3" class="collapse" data-parent="#accordion" aria-labelledby="heading-3">
                                <div class="card-body">
                                    <p>제휴 프로그램 가입 승인을 받으면, 제휴 배너와 링크를 받게 됩니다. 원하는 경우, 뉴스레터와 이메일을 통해 트링카를 홍보할 수 있습니다.</p>
                                    <p>배너나 링크는 반드시 가치 있고 적합한 콘텐트가 있는 페이지에 삽입해 주세요. 링크와 배너를 여러 다른 배너/링크 옆에 게시하는 것은 권장하지
                                        <br>않습니다.</p>
                                    <p>트링카에 가입하면 인센티브나 보상을 제공한다는 내용으로 고객을 유도하면 안 됩니다.</p>
                                    <p>또한, “트링카” 또는 "Trinka.ai”의 상표, 아니면 철자를 변형한 유사 상표로 가격을 제시하는 행위를 하면 안 됩니다. 뿐만 아니라, 도메인 이름이나
                                        <br> 메타 태그에 상표명을 사용하거나 클릭당 지불 광고에서 Trinka 웹사이트로 직접 연결하는 행위는 하지 말아야 합니다.</p>
                                    <p>아래 나열된 브랜드 및 특정 키워드로 가격을 제시하는 행위를 금합니다.</p>
                                    <p>Trinka, Trinka AI, trinka.ai, www.trinka.ai, 표절 검사기, 문법 검사기, 문법 검사, 표절 검사, 무료 표절 검사기,
                                        무료 문법 검사기, 온라인 문법 검사기,
                                        <br>글쓰기 보조, 학술 글쓰기 보조, 기술 글쓰기 보조, 교정.</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-4">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-4" aria-expanded="false" aria-controls="collapse-4">
                                        제휴 프로그램에 등록해 활동하면 어떤 혜택이 있나요?
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-4" class="collapse" data-parent="#accordion" aria-labelledby="heading-4">
                                <div class="card-body">
                                    <p>이나고의 탁월한 수익금 지급 구조를 통해 이중으로 수익을 올릴 기회를 얻습니다. 무료 가입마다 $0.21 지급, 유료 업그레이드마다 $20 지급. 프로그램
                                        등록자의 웹사이트에 삽입되는 모든 링크는 특정 추적 코드를 갖고 있습니다. 고객이 등록자의 웹사이트를 통해 클릭하여 trinka.ai로 진입해 무료
                                        트링카 브라우저 확장을 설치, 가입하거나 유료 요금제로 업그레이드할 때마다, 해당 전환은 문서화되어 해당 등록자의 계정에 반영됩니다. 언제든지 ShareASale의
                                        대시보드 또는 현황(Reports) 섹션에서 전환 및 수익을 확인할 수 있습니다. </p>
                                    <p>주의: 모든 수익금은 USD로만 지급됩니다. 미국 거주자가 아닌 경우 본인의 은행이 USD를 수취할 수 있는지 확인하세요. </p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-5">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-5" aria-expanded="false" aria-controls="collapse-5">
                                        트링카 제휴 프로그램의 약관은 어떻게 되나요?
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-5" class="collapse" data-parent="#accordion" aria-labelledby="heading-5">
                                <div class="card-body">
                                    <p>
                                        <a href="https://www.trinka.ai/termsofservices/" target="_blank">이 링크를</a> 따라 방문하면 약관을 읽어볼 수 있습니다.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 text-center">
                    <div class="bottom_shareAsale_buttons">
                        <a id="signUpAtShareASaleFooter" href="https://www.shareasale.com/shareasale.cfm?merchantID=98815" target="_blank">
                            <i class="fa fa-sign-in"></i>
                            ShareASale에서 등록
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>